import { useState, useEffect } from 'react';
import logo from '/src/img/logoRecon.png';


export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`bg-white shadow-sm fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center gap-2">
          <img
            src={logo}
            alt="Restituição Consórcio"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Como Funciona', id: 'explicativa' },
            { label: 'Consórcios', id: 'consorcios' },
            { label: 'Simular', id: 'simulador' },
            { label: 'Contato', id: 'prova-social' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-gray-700 text-sm font-medium  cursor-pointer`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('simulador')}
            className="bg-green-500 hover:bg-green-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            Simular Agora
          </button>
        </nav>

        <button
          className="md:hidden cursor-pointer p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-800' : 'text-white'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-4">
          {[
            { label: 'Como Funciona', id: 'explicativa' },
            { label: 'Consórcios', id: 'consorcios' },
            { label: 'Simular', id: 'simulador' },
            { label: 'Contato', id: 'prova-social' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-gray-700 font-medium text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('simulador')}
            className="bg-green-500 text-white font-semibold px-5 py-3 rounded-full cursor-pointer whitespace-nowrap"
          >
            Simular Agora
          </button>
        </div>
      )}
    </header>
  );
}
